import { Component } from 'react';
import styled from 'styled-components'

import { showLoading } from 'services/util'
import Alert from 'common/notifications/Alert'
import iconInfo from 'images/iconColorinfo.svg'
import * as colors from 'css/Colors'

import { getUsers } from "../adminapi"
import LinkUserWrapper from '../linkuser/LinkUserWrapper'
import UserSearchForm from './UserSearchForm'
import UserSearchResults from './UserSearchResults'

const AuditWrapper = styled.div`
  color:#fff;
  padding:20px;
  border-radius:5px;
  background-color:${ props => props.crm ? `${colors.secondaryMediumBlue}` : `${colors.primaryBlue}`};

  .user-search-form {
    margin: 0;
  }

`
class UserSearch extends Component {

  state = {
    userAction: 'Last60Days',
  };

  async componentDidMount() {
    showLoading(false)
  }

  handleSearch = async data => {
    if (["CognitoUsername","CrmId"].indexOf(data.searchType) > -1 && !data.searchValue){
      this.setState({errorMsg: 'Search field cannot be blank'})
      return;
    }

    this.setState({errorMsg: ''})
    showLoading(true)

    const response = await getUsers(data.queryApp, data.searchType, data);

    if (!response || !response.entries) {
      await this.setState({errorMsg: response && response.error ? response.error.msg || 'An Error Occurred' : 'An Error Occurred'})
      await this.setState({tableData: null});
      showLoading(false)
      return "error" // todo - handle error
    }

    const tableData = response.entries.map(entry => {
      const newEntry = {...entry};
      for (const prop in newEntry) {
        if (prop.indexOf("LastLogin") > 0) {
          if (!newEntry.AllApps) newEntry.AllApps = prop.replace('LastLogin', '')
          else newEntry.AllApps += ', ' + prop.replace('LastLogin', '')
        }
      }
      return newEntry;
    })

    await this.setState({tableData});

    showLoading(false)
  }

  render() {
    return (
      <>
        <LinkUserWrapper>
          <h2>Search IDM Users</h2>
          <p>(See Link User to CRM to check user's login method. IE - Facebook, Google, Email, LinkedIn)</p>

          {this.state.errorMsg &&
            <Alert icon={iconInfo} >
              <div>{this.state.errorMsg}</div>
            </Alert>
          }

          <div className=" grid">
            <div className="span-12">
              <AuditWrapper>
                <UserSearchForm
                  onSubmit={this.handleSearch}
                >
                </UserSearchForm>

              </AuditWrapper>
            </div>
          </div>

          <br/>

          {this.state.tableData &&
            <UserSearchResults data={this.state.tableData} />}

        </LinkUserWrapper>
      </>
    )
  }
}

export default UserSearch;
